module.exports = __webpack_public_path__ + "static/iPadAMOEBA-a47df2bdc7c2885c62a918c6cabb6b65.mp4";